'use client';

import { GoogleLogo } from 'icons/GoogleLogo';
import { useState } from 'react';
import { Icon } from '@/app_components/common/Icon';
import { trackOptimizelyEvent } from '@/app_lib/optimizely/utils';
import { useOptimizely } from '@/main/lib/hooks/useOptimizely';
import { Breakpoints, useMediaQuery } from '@/app_lib/hooks/useMediaQuery';

export const GoogleSourceBanner = ({ title, mobileTitle }: { title: string,  mobileTitle: string}) => {
  const { optimizely } = useOptimizely();
  const [isOpen, setIsOpen] = useState(true);
  const mobile = useMediaQuery(Breakpoints.Mobile);

  const openGooglePopup = () => {
    const url = 'https://www.google.com/preferences/source?q=fortune.com';
    const windowFeatures = 'menubar=no,toolbar=no,status=no,width=600,height=600,top=100,left=100';

    window.open(url, 'GooglePopup', windowFeatures);
  };

  return isOpen ? (
    <div className='flex flex-col p-4 md:px-6 max-w-[1344px] 2xl:w-full gap-4 2xl:m-auto margin-safe-area rounded-md border warning-border bg-yellow-50 shadow-[0_0_24px_0_rgba(17,17,17,0.04)] font-graphik-compact font-medium'>
      <div className='flex gap-2 md:gap-4 md:items-center'>
        <GoogleLogo className='max-md:w-5 max-md:h-5' />
        <div className='hidden lg:block text-primary typography-level-6 flex-[1_0_0] m-auto'>
          {title}
        </div>
        <div className='lg:hidden text-primary typography-xs md:typography-level-6 flex-[1_0_0] m-auto'>
          {mobileTitle}
        </div>
        <button
          aria-label='Add Fortune as a preferred source on Google - Opens in a new window'
          className='hidden md:flex justify-center items-center self-stretch px-6 py-3 rounded-full button-primary button-text-primary text-base leading-4 cursor-pointer'
          onClick={() => {
            trackOptimizelyEvent(optimizely, 'addOnGoogleClicked', {});
            openGooglePopup();
          }}
          type='button'
        >
          Add us on Google
        </button>
        <button
          aria-label='Close banner'
          onClick={() => {
            trackOptimizelyEvent(optimizely, 'closeAddOnGoogleClicked', {});
            setIsOpen(false);
          }}
          type='button'
        >
          {mobile ? (
            <Icon
              className='max-md:self-start cursor-pointer'
              icon='X'
              width={20}
              height={20}
              strokeWidth={1.5}
            />
          ) : (
            <Icon
              className='max-md:self-start cursor-pointer'
              icon='X'
            />
          )}
        </button>
      </div>
      <button
        aria-label='Add Fortune as a preferred source on Google - Opens in a new window'
        className='flex md:hidden justify-center items-center self-stretch px-4 py-2 rounded-full button-primary button-text-primary text-xs leading-4 cursor-pointer'
        onClick={() => {
          trackOptimizelyEvent(optimizely, 'addOnGoogleClicked', {});
          openGooglePopup();
        }}
        type='button'
      >
        Add us on Google
      </button>
    </div>
  ) : null;
};
